export enum LocaleEnum {
  English = 'en',
  Dutch = 'nl',
}

export const intergripNxtFirstSchoolYear = 2022;
